import * as React from "react";
function SvgCheckRound(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-5.3-1.287l.714-.7-1.401-1.427-.714.7-4.39 4.312-2.208-2.169-.714-.7-1.401 1.427.713.7 2.91 2.857.7.689.701-.689 5.09-5z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCheckRound);
export default ForwardRef;
